import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ILoginFormMeta {
  login: FormInputMeta;
  password: FormInputMeta;

  schema: any;
}

const loginFormMeta = {} as ILoginFormMeta;

loginFormMeta.login = {
  type: 'text',
  name: 'login',
  placeholder: 'Username or Email Address',
  validation: yup.string().required("Champ obligatoire !")
};

loginFormMeta.password = {
  type: 'password',
  name: 'password',
  placeholder: 'Password',
  validation: yup.string().required("Champ obligatoire !")
};

loginFormMeta.schema = yup.object().shape(getValidationSchema(loginFormMeta));

export default loginFormMeta;